import type { ReactNode } from 'react';
import { BadgeWithTooltip } from '../../BadgeWithTooltip';
import { DemoOrOverlayPageBreadcrumbs } from '../DemoOrOverlayPageBreadcrumbs';
import { TabLayout } from '../TabLayout';
import { DemoPageActionButtons } from './DemoPageActionButtons';
import { useDemoPageProps } from './DemoPageContext';
import { DemoPageTitle } from './DemoPageTitle';

interface DemoTabLayoutProps {
  children: ReactNode;
}

export const DemoPageTabLayout = ({ children }: DemoTabLayoutProps) => {
  const { readOnly } = useDemoPageProps();
  return (
    <TabLayout
      entity="demo"
      title={<DemoPageTitle />}
      breadcrumbs={<DemoOrOverlayPageBreadcrumbs />}
      actionButtons={<DemoPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      {children}
    </TabLayout>
  );
};
